import { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/newInput';
import FreeSelectMultiple from '~/components/FreeSelectMultiple';
import { GeneralParametersAgreement } from '~/services/banknow/types';
import * as St from '../styles';
import Grid from '~/components/grid';
import moment from 'moment';
import { FiTrash2 } from 'react-icons/fi';
import Button from '~/components/button';
import { icons } from '~/assets';
import Dialog from '~/components/dialog';

// Adicionando forwardRef para permitir o uso de refs e exibir o handleErrors
const GeneralAgreementData = forwardRef(({
  defaultValues,
  onChange,
}: {
  defaultValues: GeneralParametersAgreement;
  onChange: (values: GeneralParametersAgreement) => void;
}, ref) => {
  const [values, setValues] = useState({
    invoiceDueDay: { masked: '' },
    invoiceEmails: [],
    ...defaultValues,
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [dialogSelectDueDay, setDialogSelectDueDay] = useState(false);
  const diasVencimento = [1, 5, 10, 15, 20, 25];
  const diasCorte = [21, 25, 1, 4, 9, 14];

  useEffect(() => {
    onChange(values);
  }, [values]);

  // Expondo o handleErrors para o componente pai
  useImperativeHandle(ref, () => ({
    handleErrors,
  }));

  const getNestedValue = (obj, path) => {
    return path.reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
      obj,
    );
  };

  const handleErrors = () => {
    const fieldsToCheck = ['invoiceDueDay', 'invoiceEmails'];
    const errors = {};

    fieldsToCheck.forEach((field) => {
      const value = getNestedValue(values, field.split('.'));
      if (
        value === undefined ||
        value === null ||
        value === '' ||
        value.length === 0
      ) {
        errors[field] = 'Campo obrigatório';
      }

      if (!moment(values?.invoiceDueDay?.masked, 'DD').isValid()) {
        errors['invoiceDueDay'] = 'Dia inválido';
      }
    });

    setErrors(errors);

    return Object.keys(errors).length > 0;
  };

  const updateNestedValue = (obj, path, value) => {
    if (!path.length) return value;
    const [key, ...rest] = path;
    return { ...obj, [key]: updateNestedValue(obj[key] || {}, rest, value) };
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValues((prev) => updateNestedValue(prev, name.split('.'), value));
  };

  const RenderChips = ({ array, onDelete }: { array: []; onDelete: (item) => void }) => {
    if (!array?.length) return null;
    return (
      <St.Paper style={{ marginTop: 8, maxHeight: '300px', overflowY: 'scroll' }}>
        <div style={{ flexWrap: 'wrap', display: 'flex', gap: 8 }}>
          {array.map((e) => (
            <St.Chips key={e.id}>
              <div>
                <span>{e.value}</span>
                <FiTrash2 onClick={() => onDelete(e)} />
              </div>
            </St.Chips>
          ))}
        </div>
      </St.Paper>
    );
  };

  return (
    <ContainerFlex marginTop={20} marginBottom={30}>
      <Grid xs={1} sm={2} lg={2} gap={16}>
        <ContainerFlex row center marginTop={0} width={100}>
          <ContainerFlex row>
            <Input
              label="Data de Vencimento"
              name="invoiceDueDay"
              value={values.invoiceDueDay?.masked || ''}
              disabled
              maxLength={2}
              mask={MaskTypes.DATE}
              onChange={handleChange}
              errorMessage={errors['invoiceDueDay']}
            />

            <Button
              style={{ height: 50, marginLeft: 10 }}
              onClick={() => setDialogSelectDueDay(true)}
            >
              Selecionar dia
            </Button>
          </ContainerFlex>
        </ContainerFlex>

        <ContainerFlex>
          <FreeSelectMultiple
            name="invoiceEmails"
            errorMessage={errors['invoiceEmails']}
            showChips={false}
            limitTag={5}
            value={values?.invoiceEmails}
            label="Emails para envio de fatura"
            onChange={(value) =>
              setValues((prev) => ({
                ...prev,
                invoiceEmails: value,
              }))
            }
          />
          <RenderChips
            onDelete={(item) =>
              setValues((prev) => ({
                ...prev,
                invoiceEmails: prev?.invoiceEmails?.filter((p) => p.id !== item.id),
              }))
            }
            array={values?.invoiceEmails}
          />
        </ContainerFlex>
      </Grid>

      <Dialog
        icon={icons.exclamation}
        open={dialogSelectDueDay}
        title={<span style={{ color: 'red' }}>Selecione o dia de vencimento</span>}
        positiveLabel="Voltar"
        positiveAction={() => setDialogSelectDueDay(false)}
      >
        <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <St.TableHistory>
            <tr>
              <th>Dia vencimento</th>
              <th>Dia corte</th>
              <th></th>
            </tr>

            {diasVencimento.map((vencimento, index) => {
              const corte = diasCorte[index];
              const selected =
                values.invoiceDueDay?.masked ===
                String(vencimento).padStart(2, '0');

              return (
                <tr key={index}>
                  <td>{vencimento}</td>
                  <td>{corte}</td>
                  <td style={{ textAlign: 'center' }}>
                    <input
                      type="radio"
                      name="diaFechamento"
                      checked={selected}
                      onChange={() => {
                        setValues(prev => ({
                          ...prev,
                          invoiceDueDay: {
                            masked: String(vencimento).padStart(2, '0'),
                          },
                        }));
                        setDialogSelectDueDay(false);
                      }}
                      style={{ width: 20, height: 20 }}
                    />
                  </td>
                </tr>
              );
            })}
          </St.TableHistory>
        </div>
      </Dialog>

    </ContainerFlex>
  );
});

export default GeneralAgreementData;
